import * as React from "react";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from './TelemetryService';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface TelemetryProviderProps extends RouteComponentProps {
    instrumentationKey: string;
    children: React.ReactNode;
}

const TelemetryProvider: React.FC<TelemetryProviderProps> = ({ 
    instrumentationKey, 
    children, 
    history 
}) => {
    const [initialized, setInitialized] = React.useState(false);

    React.useEffect(() => {
        if (!initialized && instrumentationKey && history) {
            try {
                ai.initialize(instrumentationKey, history);
                setInitialized(true);
                console.log('Application Insights telemetry initialized successfully');
            } catch (error) {
                console.error('Failed to initialize Application Insights telemetry:', error);
            }
        }
    }, [initialized, instrumentationKey, history]);

    // Add cleanup to prevent null reference errors
    React.useEffect(() => {
        return () => {
            // Cleanup function to prevent errors during hot reload
            try {
                if (ai.appInsights) {
                    // Flush any pending telemetry
                    ai.appInsights.flush();
                }
            } catch (error) {
                // Ignore cleanup errors during development
                console.warn('Telemetry cleanup warning:', error);
            }
        };
    }, []);

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
};

// Only apply AI tracking if the service is properly initialized
const TelemetryProviderWithTracking = React.memo(TelemetryProvider);

export default withRouter(
    ai.reactPlugin ? 
        withAITracking(ai.reactPlugin, TelemetryProviderWithTracking) : 
        TelemetryProviderWithTracking
);
